// extracted by mini-css-extract-plugin
export default {"btn":"QrButton_btn__438wQ","im":"QrButton_im__VnUd8"};